import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { ServiceRegistry } from '../../models/service-registry';
import CreatableSelect from 'react-select/creatable';
import { EventService } from '../../models/event-service';

import "./regiondropdown.scss";
import { useHistory } from 'react-router-dom';
import { REGIONS } from '../../constants';


 

export default function RegionDropdown(props:any) {
   const [regions, setRegions] = useState<any[]>([]);
   const [products, setProducts] = useState<any[]>([]);
   const [regionError, setRegionError] = useState(false);
   const [productError, setProductError] = useState(false);
   const historyAPI = useHistory();
   const suboptions = [
    {
      text: "Ok",
      id: 1,
    },
    {
      text: "Cancel",
      id: 2,
    },
  ];
    const [activeIndex, setActiveIndex] = useState(null);
    const [isDisabled, setIsDisabled] = useState(false);
   const [intitialClassName, setClassName] = useState("option-button");
  const buttonsMarkup = suboptions.map((option:any,index:any) => (
    <button key={option.id} onClick={()=>{      
      if(option.text === "Ok") {
        // Validate that both regions and products are selected
        let hasError = false;
        
        if(!regions || regions.length === 0) {
          setRegionError(true);
          hasError = true;
        }
        if(!products || products.length === 0) {
          setProductError(true);
          hasError = true;
        }
        
        if(hasError) {
          return; // Don't proceed if there are errors - don't disable dropdowns
        }
        
      
        let regionsArray = regions.length===1 && regions[0].label==="All"?REGIONS.map((region:any)=>region.id):regions.map((region:any)=>region.value);
    
         historyAPI.push({
                pathname: `/products/${products[0].value}`,
                state: {
                    // filterDate: filterDate,
                    regions: regionsArray,
                    // eventIDs: eventIDs,
                    tab: products[0].offerings?"services":"events",
                    DateRange: props.state.findLast7DaysEvents? "last7Days" : props.state.findLast40DaysEvents? "last40Days" : "",
                }
            }); 
        props.actionProvider.handleFilter(regions, products);
      } else {
        props.actionProvider.handleFilter();
      }
      
      // Only disable and set active state if validation passed or it's Cancel
      setIsDisabled(!isDisabled);
      setActiveIndex(index);
      setClassName("option-inactive");
    }} className={activeIndex === index?"change-buttons":intitialClassName} disabled={isDisabled}>
      {option.text}
    </button>
  ));

    const [selectedOption, setSelectedOption] = useState<any>(null);
    const [selectedProductOption, setSelectedProductOption] = useState<any>(null);
    const serviceRegistry: ServiceRegistry = ServiceRegistry.init();


 const handleChange = (option: any) => {
    props.actionProvider.resetState();
    setSelectedOption(option);
    setRegions(option);
    setRegionError(false); // Clear error when user selects
  };

const handleProductChange = (option: any) => {
    props.actionProvider.resetState();
    setSelectedProductOption(option);
    setProducts([...products,option]);
    setProductError(false); // Clear error when user selects
  };
 function getRegionNames() {
        let regionList:any =[];
        let allValues: any =[];
        var finalregionList: any = [];
        finalregionList.push({value: allValues, label: "All"});
        regionList = serviceRegistry.getRegionList();
        if (regionList && regionList.length) {
             regionList.forEach((region: any) => {
                allValues.push(region.id);
                finalregionList.push ({
                    value: region.id, label: region.name
                });
            });
        }
       
        return finalregionList;
        
    }

 function getproductNames() {
        let productList:any =[];
        productList = serviceRegistry.getAllProducts();
        if (productList && productList.length) {
            return productList.map((product: any) => {
                return ({
                    value: product.id, label: product.name, offerings: product?.productOfferings?.length>0?true:false
                });
            });
        }
        return [];
    }

  // Auto-select default values when component mounts
  useEffect(() => {
    const regionOptions = getRegionNames();

    // Auto-select first region if available
    if (regionOptions.length > 0 && !selectedOption) {
      const defaultRegion = regionOptions[0];
      setSelectedOption([defaultRegion]);
      setRegions([defaultRegion]);
    }
  }, []);

  return (
    <div>
     <div className={`dropdown-text ${productError ? 'error' : ''}`}>Please select a product</div>
       
    <Select
        value={selectedProductOption}
        onChange={option => handleProductChange(option)}
        options={getproductNames()}
        isDisabled={isDisabled}
        isClearable
        components={{
          ClearIndicator: (props: any) => {
            const { components } = require('react-select');
            const Clear = components.ClearIndicator as React.ComponentType<any>;
            return (
              <Clear
                {...props}
                innerProps={{
                  ...props.innerProps,
                  "aria-hidden": false,
                  role: "button",
                  tabIndex: 0,
                  "aria-label": "Remove all selected products",
                  onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      props.innerProps.onMouseDown?.(e as any);
                    }
                  },
                }}
              />
            );
          }
        }}
        styles={{
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
              ? '#666666'
              : state.isFocused ? '#e0e0e0' : undefined,
            color: state.isSelected ? '#fff' : base.color,
          }),
        }}

        formatGroupLabel={(data: any) => (
          <div className="service-dd__group-heading">
            {data.label}
          </div>
        )}

      />
    <br/>
    <div className={`dropdown-text ${regionError ? 'error' : ''}`}>Please select region(s)</div>
    <Select
            isMulti
            value={selectedOption}
            onChange={option => handleChange(option)}
            options={getRegionNames()}
            isDisabled={isDisabled}
            isClearable
            components={{
              ClearIndicator: (props: any) => {
                const { components } = require('react-select');
                const Clear = components.ClearIndicator as React.ComponentType<any>;
                return (
                  <Clear
                    {...props}
                    innerProps={{
                      ...props.innerProps,
                      "aria-hidden": false,
                      role: "button",
                      tabIndex: 0,
                      "aria-label": "Remove all selected regions",
                      onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          props.innerProps.onMouseDown?.(e as any);
                        }
                      },
                    }}
                  />
                );
              }
            }}
            styles={{
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected
                  ? '#666666'
                  : state.isFocused ? '#e0e0e0' : undefined,
                color: state.isSelected ? '#fff' : base.color,
              }),
            }}
        />
            
    <br/>
   

    <div className="options-container">{buttonsMarkup}</div>

    <br/>
    </div>
  );
}
